import { usePassportProvider } from "@/context";
import { useGetWalletLatestEarnings } from "@/hooks/api";
import { useQuestSections, useQuests } from "@/hooks/cms";
import { QuestsSection } from "@components/TilesSection/QuestsSection";
import { QuestTileType } from "@imx-tokens-ts/gems-game/domain";

export const PromotedSeriesQuests = () => {
  const { walletAddress } = usePassportProvider();
  const { latestEarnings } = useGetWalletLatestEarnings(walletAddress);
  const { data: allQuestSections } = useQuestSections();
  const questSections = allQuestSections?.filter(
    (questSection) => questSection.promoted,
  );
  const { data, isLoading } = useQuests();
  const seriesQuests = data?.seriesQuests || [];

  return questSections?.map((questSection) => (
    <QuestsSection
      tileType={QuestTileType.SeriesQuest}
      title={questSection.title}
      description={questSection.description}
      latestEarnings={latestEarnings}
      filterOptions={[]} // ready to be toggled on
      data={seriesQuests}
      questIDs={questSection.questIDs}
      key={questSection.slug}
      testId="SeriesQuest"
      isLoading={isLoading}
    />
  ));
};
